var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.498779,
    y: 0.21582,
    width: 40.5,
    height: 39,
    rx: 19.5,
    fill: "#F58320"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7943 20.5113C33.2336 20.072 33.2336 19.3597 32.7943 18.9203L25.6348 11.7609C25.1955 11.3215 24.4832 11.3215 24.0438 11.7609C23.6045 12.2002 23.6045 12.9125 24.0438 13.3519L30.4078 19.7158L24.0438 26.0798C23.6045 26.5191 23.6045 27.2314 24.0438 27.6708C24.4832 28.1101 25.1955 28.1101 25.6348 27.6708L32.7943 20.5113ZM9.49878 20.8408H31.9988V18.5908H9.49878V20.8408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4e89777992fdf34f14e259c6d5c96e1e.svg";
export { ForwardRef as ReactComponent };